import { useEffect } from 'react';
import PageSeo from '@/seo/PageSeo';
import { sendGAPageview } from '../utils/gaConsent';
import $ from 'jquery';
import { useSearchParams } from 'react-router-dom';
import Tools from '@/components/Tools/Tools';
import APIContent from '../components/API/APIContent';
import { useAuthStatus } from '@/store';

export default function Api() {
  const [searchParams] = useSearchParams();
  const { isAuthenticated, isAuthenticating } = useAuthStatus();

  const hasSection = searchParams.has('section');

  useEffect(() => {
    $('.popover').hide();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      sendGAPageview({ hitType: 'pageview', page: '/Tools', title: 'Tools' });
    }
  }, [isAuthenticated]);

  if (isAuthenticating) return null;

  return (
    <>
      <PageSeo
        title="Gene-Disease Association API, R Package & Cytoscape | DISGENET"
        description="Query DISGENET via REST API, R package, Cytoscape app and MCP connector. Programmatic access to curated gene-disease and variant-disease data."
        path="/Tools"
      />
      {hasSection ? <APIContent /> : <Tools />}
    </>
  );
}
